/**
 * The agreement wording lives in `public/agreements/*.md` so it can be edited
 * as a plain document without touching code. Bump `version` whenever the text
 * changes materially: it is stored on the user as `termsVersion`.
 */
export const CUSTOMER_AGREEMENT = {
    version: "customer-2026-07-01",
    title: "Customer User Agreement",
    url: "/agreements/customer-agreement.md",
};

/**
 * Minimal Markdown reader for the agreement documents: ATX headings, blank-line
 * separated paragraphs, and `**bold**` runs. Anything else renders as plain text.
 */
export function parseAgreement(markdown) {
    const blocks = [];

    for (const raw of markdown.replace(/\r\n/g, "\n").split(/\n{2,}/)) {
        const block = raw.trim();
        if (!block) continue;

        const lines = block.split("\n");
        const heading = lines[0].match(/^(#{1,6})\s+(.*)$/);

        if (heading) {
            blocks.push({ type: `h${heading[1].length}`, text: heading[2].trim() });
            const rest = lines.slice(1).join(" ").trim();
            if (rest) blocks.push({ type: "p", text: rest });
            continue;
        }

        blocks.push({ type: "p", text: lines.join(" ") });
    }

    return blocks;
}

/** Split a line into plain and bold runs for rendering. */
export function splitBold(text) {
    return text
        .split(/(\*\*[^*]+\*\*)/g)
        .filter(Boolean)
        .map((part) =>
            part.startsWith("**") && part.endsWith("**")
                ? { bold: true, text: part.slice(2, -2) }
                : { bold: false, text: part }
        );
}
